import React from 'react';
import { useTranslation } from 'react-i18next';
import { CircleHelp, MessageSquare } from 'lucide-react';
import { ShellPopover } from './ShellPopover';
import { SUPPORT_EMAIL } from './support';

/**
 * The help popover.
 *
 * CT-0 also lists Documentation, Video walkthroughs, Keyboard shortcuts and
 * three popular articles. None of those exist: there is no docs site, no
 * video library and no keyboard shortcuts in the app. They are left out
 * rather than rendered as links that go nowhere — each one needs the thing it
 * points at to exist first.
 */
export const HelpPopover: React.FC = () => {
  const { t } = useTranslation();
  const label = t('app.v11.shell.help.title');

  return (
    <ShellPopover
      ariaLabel={label}
      trigger={
        <button
          type="button"
          aria-label={label}
          title={label}
          className="flex h-9 w-9 items-center justify-center rounded-[8px] text-[rgba(11,11,11,0.7)] transition hover:bg-v11-surface-hover dark:text-white/70"
        >
          <CircleHelp className="h-[18px] w-[18px]" strokeWidth={1.6} />
        </button>
      }
    >
      <div className="p-2">
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm text-v11-text-secondary transition hover:bg-v11-surface-hover hover:text-v11-text-primary"
        >
          <MessageSquare className="h-4 w-4" />
          {t('app.v11.shell.help.contactSupport')}
        </a>
      </div>
    </ShellPopover>
  );
};
